import { createContext, useContext, useEffect, useState } from "react";

// create context
const CartContext = createContext();

// custom hook to use cart
export const useCart = () => useContext(CartContext);

// provider component
export function CartProvider({ children }) {
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });
  console.log(cart);

  //   load cart from localstorage on first render
  //   useEffect(() => {
  //     const savedCart = localStorage.getItem("cart");
  //     if (savedCart) {
  //       setCart(JSON.parse(savedCart));
  //     }
  //   }, []);

  //   Save cart to localstorage whenever it changes
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  localStorage.clear();

  // Add product to cart
  const addToCart = (product) => {
    setCart((prevCart) => {
      const existing = prevCart.find((item) => item.id === product.id);

      if (existing) {
        return prevCart.map((item) => {
          if (item.id === product.id) {
            const newQuantity =
              item.quantity < item.overalltotalquantity
                ? item.quantity + 1
                : item.quantity;
            return {
              ...item,
              quantity: newQuantity,
              totalquantity:
                item.totalquantity > 0
                  ? item.totalquantity - 1
                  : item.totalquantity,
              price: item.overallprice * newQuantity,
              overalltotalquantity: item.overalltotalquantity,
              overallprice: item.overallprice,
            };
          }
          return item;
        });
      } else {
        return [
          ...prevCart,
          {
            ...product,
            quantity: 1,
            totalquantity: product.overalltotalquantity - 1,
            price: product.overallprice * 1,
          },
        ];
      }
    });
  };

  //   remove product completely
  const removeFromCart = (id) => {
    setCart((prevCart) => prevCart.filter((item) => item.id !== id));
  };

  //   Decrease quantity
  const decreaseQuantity = (id) => {
    setCart((prevCart) =>
      prevCart
        .map((item) => {
          if (item.id === id) {
            const newQuantity =
              item.quantity > 0 ? item.quantity - 1 : item.quantity;

            return {
              ...item,
              quantity: newQuantity,
              totalquantity: item.totalquantity + 1,
              price: item.overallprice * newQuantity,
            };
          } else {
            return item;
          }
        })
        .filter((item) => item.quantity > 0)
    );
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeFromCart,
        decreaseQuantity,
        setCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}
